export const personKeys = {
  all: ["person"] as const,
  person: (personId: string) => [...personKeys.all, personId] as const,
  project: (projectId: string | null) => [...personKeys.all, projectId] as const,
};
